module.exports = __webpack_public_path__ + "europa-200-portrait_window.jpg?c95923f7d0b5888213bb3d9f4374f9ff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-200-portrait_window.jpg
// module id = 311
// module chunks = 0